export default __webpack_public_path__ + "static/media/640_business05-it-web.3079aa54.png";